const STORAGE_KEY = 'app-test-inbox-dismissed'

export function readInboxDismissedKeys(userId: string): Set<string> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return new Set()
    const parsed = JSON.parse(raw) as Record<string, string[]>
    return new Set(parsed[userId] ?? [])
  } catch {
    return new Set()
  }
}

export function writeInboxDismissedKeys(userId: string, keys: Set<string>) {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    const parsed = raw ? (JSON.parse(raw) as Record<string, string[]>) : {}
    parsed[userId] = [...keys]
    localStorage.setItem(STORAGE_KEY, JSON.stringify(parsed))
  } catch {
    // ignore quota / parse errors
  }
}

export function addInboxDismissedKey(userId: string, key: string, current: Set<string>): Set<string> {
  const next = new Set(current)
  next.add(key)
  writeInboxDismissedKeys(userId, next)
  return next
}
